<template>

	<div class="cc-app">

		<div class="cc-card" v-if="dataLoading">

			<div class="cc-loading"></div>

		</div>

		<!-- <DatePicker
			v-if="!dataLoading"
			:columns='columns'
			:rows="rows"
			is-range
			v-model="range"
			:is-inline="true"
			@input="selectedDatesEvent"
			:disabled-dates="dates_without_stock"
			:attributes="calendarAttributes"
		/> disabledDates-->

		<CalendarMonth
		v-if="!dataLoading"
		:disabled-dates="dates_without_stock"
		:arrival_dates="arrival_dates"
		:departure_dates="departure_dates"
		/>

	</div>

</template>

<style lang="scss">

@import "../../assets/scss/main.scss" ;
@import "../../assets/scss/components/_calendar.scss" ; 

.cc-app .vc-day-content.is-disabled {
    color: #e91e63;
}

/* .cc-app .vc-day-content.vc-focusable {
    color: #fff;
    background-color: green;
}

.cc-app .vc-day-content.is-disabled {
    color: #fff;
    background-color: #e91e63;
} */

</style>

<script>
import moment from "moment";
// import DatePicker from "v-calendar/lib/components/date-picker.umd";
import class_accommodation from "../../api/accommodations/accommodation.js";
import helpers from "../../helpers.js"

import CalendarMonth from "./CalendarMonth.vue";

import store from "../../store";
import { mapGetters } from "vuex";

export default {
	store,
	name: "cc-Calendar",

	components: {
		// DatePicker,
		CalendarMonth
	},

	watch: {

		// range: {
		// 	start(){
		// 		console.log('Date range changes');

		// 		this.selectedDatesEvent();
		// 	},
		// 	deep:true
		// },			
		accommodation_id(){
			
			if (this.accommodation_id) {
				this.dataLoading = true
				this.getArrivalAndDepartureDays();
			}
			
		},
		vertical(){
			
			if (this.vertical) {
				this.columns = 1 ;
				this.rows = 2 ;				
			}
			
		},

		
	},

	data() {
		return {
			dataLoading: false,
			range: null,
			//Data for details in the calender
			arrival_dates: null,
			departure_dates: null,
			dates_without_stock: [
				{
					start: "",
					end: moment().subtract(1, 'days').toDate()
				},
				{
					start: moment()
						.add(548, "days")
						.toDate(),
					end: ""
				}
			],
			calendarAttributes: [
				{
					dates: [],
					dot: "green",
					popover: {
						label: "Arrival day",
					}
				},
				{
					dates: [],
					dot: "orange",
					popover: {
						label: "Departure day",
					}
				}
				
			]
		};
	},

	computed: {

		nights() {

			if(this.range){

				let start = moment(this.range.start);
				let end = moment(this.range.end);

				return end.diff(start, "days");
				
			}

			return 0 ;
			
		},

		accommodation_id(){

			if(this.settings && this.settings.accommodation_id){
				return this.settings.accommodation_id ;
			}else{
				return null ;
			}

		},

        // map `this.administrationTest` to `this.$store.getters.administrationTest`
        ...mapGetters({
            settings: "app/settings",
            administration: "administration/get",
            priceCalculation: "priceCalculation/get"
		})
		
	},

	model: {
		prop: "selectedDates",
		event: "selecteddates",
	},

	props: {

        columns: {
            type: Number,
            default: 2
		},
		rows: {
            type: Number,
            default: 1
		},
        vertical: {
            type: Boolean,
            default: false
        }
	},

	methods: {
		selectedArrival() {
			this.$emit(
				"selectarrival",
				moment(this.arrival).format("YYYY-MM-DD")
			);
		},

		selectedDeparture() {
			this.$emit(
				"selectdeparture",
				moment(this.departure).format("YYYY-MM-DD")
			);
			// this.selectedDatesEvent();
		},

		getArrivalAndDepartureDays() {

			console.log('this.accommodation_id', this.accommodation_id); 

			if(this.accommodation_id && this.accommodation_id != 'null'){

				console.log('this.accommodation_id1111', this.accommodation_id); 

				const Accommodation = new class_accommodation();

				Accommodation.set_accommodation_id(this.accommodation_id);
				// Accommodation.set_admin_id(1153);
				Accommodation.set_meta(true);
				// Accommodation.set_public_key("6n5gNUwmhwT9JMBYwOGI9dri");
				Accommodation.get().then((accommodationData) => {

					console.log('accommodationData'); 
					console.log(accommodationData.meta); 

					if(accommodationData.meta.arrival_days){

						
						if (typeof accommodationData.meta.arrival_days === "string" || accommodationData.meta.arrival_days instanceof String) {
							this.arrival_dates = JSON.parse(accommodationData.meta.arrival_days);
						} else {
							this.arrival_dates = accommodationData.meta.arrival_days;
						}

					}

					if(accommodationData.meta.departure_days){

						if (typeof accommodationData.meta.departure_days === "string" || accommodationData.meta.departure_days instanceof String) {
							this.departure_dates = JSON.parse(accommodationData.meta.departure_days);
						} else {
							this.departure_dates = accommodationData.meta.departure_days;
						}

					}
					
					//Set expecptions 
					if(accommodationData.meta.dates_without_stock){


						if (typeof accommodationData.meta.dates_without_stock === "string" || accommodationData.meta.dates_without_stock instanceof String) {
							this.dates_without_stock = JSON.parse(accommodationData.meta.dates_without_stock);
						} else {
							this.dates_without_stock = accommodationData.meta.dates_without_stock;
						}

					}

					this.dataLoading = false;

				});
				
			}else{

				this.accommodation_id = null ;

				this.dates_without_stock = {
					start: "",
					end: moment().subtract(1, 'days').toDate()
				},
				{
					start: moment()
						.add(548, "days")
						.toDate(),
					end: ""
				};

				this.dataLoading = false ;

			}
			
		},

		setRange(){

			console.log('range 0', this.range);

			this.range = {
				start: moment(this.arrival, "YYYY-MM-DD").toDate(),
				end: moment(this.departure, "YYYY-MM-DD").toDate()
			}

			console.log('range', {
				start: moment(this.arrival, "YYYY-MM-DD").toDate(),
				end: moment(this.departure, "YYYY-MM-DD").toDate()
			});

			// console.log('range 2', this.range);
			// console.log('departure', moment(this.departure, "YYYY-MM-DD").toDate());

		}
	},

	created() {
		
		if(!this.selectedDates){
				
			this.arrival = helpers.get_arrival(this.arrival) ;
			this.departure = helpers.get_departure(this.departure) ;

			if(!this.arrival){ this.arrival = moment().format("YYYY-MM-DD"); }
			if(!this.departure){ this.departure = moment().add(7, 'days').format("YYYY-MM-DD"); }

			this.selectedDates = {
				arrival: this.arrival,
				departure: this.departure,
				nights: this.nights
			} 
			
		}else{

			this.arrival = this.selectedDates.arrival ;
			this.departure = this.selectedDates.departure ;

		}

		this.setRange(); 
		// this.selectedDatesEvent();

		if (this.accommodation_id) {
			this.dataLoading = true
			this.getArrivalAndDepartureDays();
		}

		if (this.vertical) {
			this.columns = 1 ;
			this.rows = 1 ;				
		}

	},
};
</script>

<style >
.vc-text-gray-400{
	color: red;
}

</style>
